import React from 'react';
import DownloadFloatingModal from 'Components/DownloadFloatingModal';

export const flowFloatingMapType = {
  GENERIC_FLOATING_DOWNLOAD_TILE: 'GENERIC_FLOATING_DOWNLOAD_TILE',
}

export const flowFloatingMap = {
  [flowFloatingMapType.GENERIC_FLOATING_DOWNLOAD_TILE]: <DownloadFloatingModal />
}

export const getFloatingByID = (id) => flowFloatingMap[id];

export default flowFloatingMap;